import _defineProperty from "/builds/speachme/speachmeDesktop/speach-front/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.map.js";
import { __decorate } from "tslib";
import StandardButton from "@/components/buttons/StandardButton.vue";
import { Component, Emit, Prop, Vue } from "vue-facing-decorator";
import WInput from "@/components/form/w-input.vue";
import QuizSimpleTextQuestion from "@/components/quiz/QuizSimpleTextQuestion.vue";
import QuizReadonlyAlert from "@/components/quiz/QuizReadonlyAlert.vue";
let OpenQuestion = class OpenQuestion extends Vue {
  constructor(...args) {
    super(...args);
    _defineProperty(this, "quiz", void 0);
    _defineProperty(this, "userQuestionsAnswers", void 0);
    _defineProperty(this, "isResultMode", void 0);
    _defineProperty(this, "realtimeUserAnswer", null);
  }
  mounted() {
    this.realtimeUserAnswer = {
      contenuQuizId: this.quiz.id,
      questions: this.userQuestionsAnswers
    };
    if (this.quiz && this.userQuestionsAnswers.length === 0) {
      this.realtimeUserAnswer = this.initRealtimeUserAnswer(this.quiz);
    }
  }
  initRealtimeUserAnswer(quiz) {
    return {
      contenuQuizId: quiz.id,
      questions: quiz.questions?.map(question => ({
        questionId: question.id,
        questionType: question.type,
        order: question.order,
        blanksText: question.blanksText,
        responsesIds: [],
        responseContent: ''
      })) || []
    };
  }
  get userAnswer() {
    const questionResult = this.realtimeUserAnswer?.questions[0];
    if (!questionResult) {
      return '';
    }
    return questionResult.responseContent;
  }
  onAnswerChange(answer) {
    if (this.realtimeUserAnswer) {
      this.realtimeUserAnswer.questions[0].responseContent = answer;
    }
    return this.realtimeUserAnswer;
  }
};
__decorate([Prop({
  required: true
})], OpenQuestion.prototype, "quiz", void 0);
__decorate([Prop({
  default: []
})], OpenQuestion.prototype, "userQuestionsAnswers", void 0);
__decorate([Prop({
  default: false
})], OpenQuestion.prototype, "isResultMode", void 0);
__decorate([Emit('answerChange')], OpenQuestion.prototype, "onAnswerChange", null);
OpenQuestion = __decorate([Component({
  components: {
    QuizReadonlyAlert,
    QuizSimpleTextQuestion,
    WInput,
    StandardButton
  }
})], OpenQuestion);
export default OpenQuestion;